export default {
  // KD customer customized menu names (overrides defaults)
  // 'menu.process.MAN.3': 'MAN.3 Project Planning',
  // 'menu.process.SUP.1': 'SUP.1 Software Validation and Validation',
  'menu.process.SWE.3': 'SWE.3 Software Detailed Design',
  'menu.process.SWE.4': 'SWE.4 Software Unit Testing',
  'menu.process.SWE.5': 'SWE.5 Software Integration Testing',
  'menu.process.SWE.6': 'SWE.6 Software System Testing',
  'menu.process.SUP.9': 'SUP.9 Problem Management',
  'menu.process.SVV.1': 'SVV.1 Software Verification',
  'menu.process.SVV.2': 'SVV.2 Software Confirmation',
  'menu.process.SPL.2': 'SPL.2 Product Release',
};
